import { render, staticRenderFns } from "./roughlyInfo.vue?vue&type=template&id=a9f14a14&scoped=true&"
import script from "./roughlyInfo.vue?vue&type=script&lang=js&"
export * from "./roughlyInfo.vue?vue&type=script&lang=js&"
import style0 from "./roughlyInfo.vue?vue&type=style&index=0&id=a9f14a14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f14a14",
  null
  
)

export default component.exports